import RequestAbstract from '../abstract';

export default class SmeCompanyEmployees extends RequestAbstract {
    constructor(data) {
        super(data);
        this.link = 'api/sme-company-employees';
    }

    async importEmployees(companyId, employeesData) {
        return await this.loadWithAuth(
            `api/sme-companies/${companyId}/employees/import`,
            {
                method: 'POST',
                body: JSON.stringify(employeesData)
            }
        );
    }
}
